// extracted by mini-css-extract-plugin
module.exports = {"Final":"Final_Final__2_K44","Title":"Final_Title__1rSYh","List":"Final_List__21zNp","Item":"Final_Item__3Dsd9"};